import React, { useState } from "react";
import { Drawer } from "@mui/material";
import { Link } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";

const Sidebar = ({ page, themeClass, setPage, setResultN }) => {
  const [isOpen, setIsOpen] = useState(false);

  const sidebarContents = [
    { category: "MAIN", items: [{ text: "Home", new: "false" }] },
    {
      category: "LEVELING",
      items: [
        { text: "Exp", new: "false" },
        { text: "Grind", new: "false" },
      ],
    },
    {
      category: "TRAINING",
      items: [
        { text: "Simulator", new: "true" },
        { text: "Afk train", new: "false" },
        { text: "Power Train", new: "false" },
        { text: "Damage", new: "false" },
        // { text: "Tank Monster", new: "false" },
        { text: "Offline", new: "false" },
        { text: "Potion Cost", new: "false" },
        { text: "Stat", new: "false" },
      ],
    },
    {
      category: "PVP",
      items: [
        { text: "Skull", new: "false" },
        { text: "Lizard Route", new: "false" },
      ],
    },
  ];

  return (
    <>
      <button onClick={() => setIsOpen(true)} className="fixed top-4 left-4 z-50">
        <div className="rpg-btn primary" style={{ padding: '10px 15px', width: 'auto' }}>
            MENU
        </div>
      </button>
 
      <Drawer anchor="left" open={isOpen} onClose={() => setIsOpen(false)}>
        <div className="w-[260px] h-full overflow-y-auto p-4">
          <h2 className="text-xl text-center mb-6 text-[#fbfaaa] pb-2" style={{borderBottom: '4px solid #000'}}>INVENTORY</h2>
          
          {sidebarContents.map((category, index) => (
            <div key={index} className="mb-6">
              <p className="text-[#2563EB] mb-2 text-[10px] tracking-wider uppercase pl-1">{category.category}</p>
              <div className="flex flex-col gap-2">
              {category.items.map((item, itemIndex) => (
                <div key={itemIndex}>
                  {item.text === "Home" ? ( 
                    <Link to="/" onClick={() => setIsOpen(false)}>
                       <button className={`rpg-btn w-full text-left ${page === item.text ? 'gold' : ''}`}>
                         {item.text}
                       </button>
                    </Link>
                  ) : (
                    <button
                      onClick={() => { setPage(item.text); setResultN(""); setIsOpen(false); }}
                      className={`rpg-btn w-full text-left ${page === item.text ? 'gold' : ''}`}
                    >
                      {item.text}{item.new === "true" && <span className="text-yellow-400 text-xs ml-2">NEW!</span>}
                    </button>
                  )}
                </div>
              ))}
              </div>
            </div>
          ))}
        </div>
      </Drawer>

      <Link to={"/"} className="fixed bottom-4 left-4 z-50">
        <div className="rpg-btn" style={{width: '50px', background: '#b91c1c'}}>
          <ArrowBack fontSize="medium" />
        </div>
      </Link>
    </>
  );
};

export default Sidebar;